import React from 'react';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";


export default function ArgoCheckboxHook(props) {

    const fileName = props.fileName ?? "NoFileName";
    const fieldName = props.fieldName ?? "NoFieldName";

    const uniqueIdentifier = fileName + "-ArgoCheckboxHook-" + fieldName;

    const label = props.label ?? "Label";
    const labelColor = props.labelColor ?? "black";
    const checked = props.checked;
    const onChange = props.onChange ?? function () {};
    const display = props.display === undefined ? "inline" : "none";
    const disabled = props.disabled ?? false;
    const paddingTop = props.paddingTop ?? "3px";
    const bold = props.bold ?? false;
    const width = props.width ?? "180px";
    const fontSize = props.fontSize ?? "16px";
    const checkBoxPaddingTop = props.checkBoxPaddingTop ?? "1px";

    const stateObjName = props.stateObjName ?? "";
    const metadataTag = props.metadataTag ?? "";

    const handleOnChange = (event) => {
        onChange(event, fieldName, stateObjName, metadataTag); // metadataTag is used when updating a metadata object is required.
    };

    return (
        <div id={uniqueIdentifier + "-container-div"} style={{paddingTop: paddingTop, width: width}}>
            <FormControlLabel
                id={uniqueIdentifier}
                name={uniqueIdentifier}
                label={bold ? <b>{label}</b> : label}
                disabled={disabled}
                sx={{paddingTop: paddingTop, display: display, color: labelColor, marginRight: 0}}
                control={<Checkbox sx={{paddingTop: checkBoxPaddingTop}}
                                   checked={checked}
                                   onChange={handleOnChange}
                                   onKeyDown={(e) => {
                                       if (e.key === "Enter") {
                                           e.preventDefault()
                                           handleOnChange({target: {checked: !checked}}, fieldName, stateObjName, metadataTag); // metadataTag is used when updating a metadata object is required.
                                       }
                                   }}
                />}
                componentsProps={{ typography: { fontSize: fontSize} }}
            />
        </div>
    );
}


